/// <amd-module name="Artifacts/FeedSettings/containers/UpstreamsTabContainer" />

import { AddUpstreamPanel } from "Artifacts/FeedSettings/components/AddUpstreamPanel";
import { UpstreamsTab } from "Artifacts/FeedSettings/components/UpstreamsTab";
import { useUpstreamSelection } from "Artifacts/FeedSettings/hooks/UpstreamSelection";
import { FeedSettingsActions, IFeedSettingsModuleState } from "Artifacts/FeedSettings/redux";
import { IFeedSettings } from "Artifacts/FeedSettings/types";
import { ComponentState } from "Artifacts/Root/Constants";
import { isPublicFeed } from "Artifacts/Root/helpers/FeedHelpers";
import { isUserFeedAdmin } from "Artifacts/Root/helpers/UserHelpers";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { IRoutedTabContainerProps } from "Artifacts/Root/types/IRoutedTabContainerProps";
import * as React from "react";
import { connect } from "react-redux";
import { IListSelection, ListSelection } from "VSSUI/List";

type IUpstreamsTabContainerProps = IRoutedTabContainerProps &
  IUpstreamsTabMapStateToProps &
  typeof Actions;

interface IUpstreamsTabMapStateToProps {
  componentState: ComponentState;
  saveUpstreamsComponentState: ComponentState;
  settings?: IFeedSettings;
  isUpstreamsDirty: boolean;
}

const Actions = {
  updateUpstreamList: FeedSettingsActions.updateUpstreamList,
  saveUpstreamConfiguration: FeedSettingsActions.saveUpstreamConfiguration,
  resetUpstreamConfigurationComponentState:
    FeedSettingsActions.saveUpstreamConfigurationComponentReset,
};

function mapStateToProps(state: IFeedSettingsModuleState): IUpstreamsTabMapStateToProps {
  const hubState = state["feed-settings"].hubState;
  return {
    componentState: hubState.componentState,
    settings: hubState.settings,
    saveUpstreamsComponentState: hubState.saveUpstreamsComponentState,
    isUpstreamsDirty: hubState.isUpstreamsDirty,
  };
}

const UpstreamsTabContainer: React.FC<IUpstreamsTabContainerProps> = ({
  componentState,
  saveUpstreamsComponentState,
  settings,
  updateUpstreamList,
  saveUpstreamConfiguration,
  resetUpstreamConfigurationComponentState,
  isUpstreamsDirty,
}) => {
  const [selection] = React.useState<IListSelection>(
    () => new ListSelection({ multiSelect: true, selectOnFocus: false }),
  );
  const { selectedUpstreams } = useUpstreamSelection(selection, settings?.upstreamSources);
  const { feed } = useFeed();
  const [showAddUpstreamPanel, setShowAddUpstreamPanel] = React.useState<boolean>(false);

  const isFeedPublic: boolean = isPublicFeed(feed);

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const saveUpstreamsOnSuccess = () => {};
  return (
    <>
      <UpstreamsTab
        feed={feed}
        upstreamList={settings?.upstreamSources}
        upstreamStatuses={settings?.upstreamStatuses}
        selectedUpstreams={selectedUpstreams}
        selection={selection}
        showAddUpstreamPanel={() => setShowAddUpstreamPanel(true)}
        setUpstreamList={updateUpstreamList}
        saveUpstreamConfiguration={() =>
          feed &&
          settings &&
          saveUpstreamConfiguration(feed, settings.upstreamSources, saveUpstreamsOnSuccess)
        }
        componentState={componentState}
        saveUpstreamsComponentState={saveUpstreamsComponentState}
        isUpstreamsDirty={isUpstreamsDirty}
        isUserAdmin={feed !== undefined && isUserFeedAdmin(feed)}
        resetUpstreamConfigurationComponentState={resetUpstreamConfigurationComponentState}
      />
      {showAddUpstreamPanel && (
        <AddUpstreamPanel
          onDismiss={() => setShowAddUpstreamPanel(false)}
          onSuccess={() => {
            setShowAddUpstreamPanel(false);
          }}
          isPublicFeed={isFeedPublic}
        />
      )}
    </>
  );
};

const ConnectedUpstreamsTabContainer = connect<
  IUpstreamsTabMapStateToProps,
  unknown,
  IRoutedTabContainerProps
>(
  mapStateToProps,
  Actions,
)(UpstreamsTabContainer);

export { ConnectedUpstreamsTabContainer as UpstreamsTabContainer, IUpstreamsTabContainerProps };
